import React from 'react';
import cx from 'classnames';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: props => props.bgColor,
    paddingBottom: props => (props.noMargin ? 'none' : theme.spacing(5)),
    padding: props =>
      props.noMargin ? theme.spacing(5, 0, 0, 0) : theme.spacing(5, 0),
  },
}));

const Section = props => {
  const { className, noMargin, bgColor, ...restProps } = props;
  const classes = useStyles(props);
  return <section className={cx(classes.root, className)} {...restProps} />;
};

Section.defaultProps = {
  bgColor: 'transparent',
  noMargin: false,
};

export default Section;
